import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Sponsorship',
    field: 'sponsorship',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'id',
      fk: 'sponsorshipId',
      namespace: 'sponsorship',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Purchase',
    field: 'purchase',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'id',
      fk: 'purchaseId',
      namespace: 'purchase',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
